// Central data-testid registry so tests + implementation stay in sync.
export const HOME = {
    langToggleEn: "lang-toggle-en",
    langToggleEs: "lang-toggle-es",
    navLogo: "nav-logo-link",
    navContact: "nav-contact-link",
    navAdmin: "nav-admin-link",
    heroCallBtn: "hero-call-btn",
    heroWhatsappBtn: "hero-whatsapp-btn",
    heroLogoMain: "hero-logo-main",
    heroLogoSecondary: "hero-logo-secondary",
    heroSoundToggle: "hero-sound-toggle",
    marquee: "editorial-marquee",
    manifestoSection: "manifesto-section",
    catalogueSection: "catalogue-section",
    catalogueCard: (slug) => `catalogue-card-${slug}`,
    occasionsSection: "occasions-section",
    gallerySection: "gallery-section",
    galleryItem: (id) => `gallery-item-${id}`,
    galleryLightbox: "gallery-lightbox",
    galleryPrev: "gallery-prev",
    galleryNext: "gallery-next",
    galleryClose: "gallery-close",
    availabilitySection: "availability-section",
    availabilityJumperOption: (slug) => `availability-jumper-${slug}`,
    availabilityCalendar: "availability-calendar",
    availabilityFormName: "availability-form-name",
    availabilityFormPhone: "availability-form-phone",
    availabilityFormEmail: "availability-form-email",
    availabilityFormOccasion: "availability-form-occasion",
    availabilityFormMessage: "availability-form-message",
    availabilityFormSubmit: "availability-form-submit",
    testimonialsSection: "testimonials-section",
    contactSection: "contact-section",
    contactForm: "contact-form",
    contactFormName: "contact-form-name",
    contactFormEmail: "contact-form-email",
    contactFormPhone: "contact-form-phone",
    contactFormMessage: "contact-form-message",
    contactFormOccasion: "contact-form-occasion",
    contactFormSubmit: "contact-form-submit",
    footer: "site-footer",
    footerPhone: "footer-phone-link",
    footerWhatsapp: "footer-whatsapp-link",
    footerAdmin: "footer-admin-link",
    emergentLink: "emergent-link",
};

export const LOGIN = {
    root: "login-page",
    email: "login-email-input",
    password: "login-password-input",
    submit: "login-submit-btn",
    error: "login-error-message",
};

export const ADMIN = {
    root: "admin-dashboard",
    logout: "admin-logout-btn",
    tabSettings: "admin-tab-settings",
    tabProducts: "admin-tab-products",
    tabTestimonials: "admin-tab-testimonials",
    tabMessages: "admin-tab-messages",
    tabBookings: "admin-tab-bookings",
    tabGallery: "admin-tab-gallery",
    galleryAddBtn: "admin-gallery-add-btn",
    galleryDeleteBtn: (id) => `admin-gallery-delete-${id}`,
    bookingConfirm: (id) => `admin-booking-confirm-${id}`,
    bookingDecline: (id) => `admin-booking-decline-${id}`,
    bookingDelete: (id) => `admin-booking-delete-${id}`,
    productList: "admin-product-list",
    productAddBtn: "admin-product-add-btn",
    productSaveBtn: "admin-product-save-btn",
    productDeleteBtn: (id) => `admin-product-delete-${id}`,
    productEditBtn: (id) => `admin-product-edit-${id}`,
    testimonialAddBtn: "admin-testimonial-add-btn",
    settingsSaveBtn: "admin-settings-save-btn",
};
